import { useEffect } from "react";
import { buildWorkflow } from "../sendWorkflow/builder/workflowBuilder";
import { useWorkflowStore } from "../store/sendmoneyWorkflowStore";
import { useWorkflowContextStore } from "../store/sendmoneyWorkflowContextStore";

/**
 * Purpose:
 * Initializes the Send Money workflow.
 *
 * Why:
 * Builds the active workflow based on the current
 * workflow context and stores it in WorkflowStore.
 *
 * Responsibilities:
 * - Build workflow
 * - Store active workflow
 * - Set initial current step
 *
 * Does NOT:
 * - Navigate between screens
 * - Validate user input
 * - Call APIs
 */
export function useWorkflowInitialization(

): void {

  const workflowContext =
  useWorkflowContextStore(
    state => state.workflowContext
  );
  
  const setWorkflow = useWorkflowStore(
    (state) => state.setWorkflow
  );

  const setCurrentStep = useWorkflowStore(
    (state) => state.setCurrentStepKey
  );

  useEffect(() => {
    const workflow = buildWorkflow(workflowContext);
    setWorkflow(workflow);

    const { currentStepKey } = useWorkflowStore.getState();
    if (workflow.length > 0 && !currentStepKey) {
      setCurrentStep(workflow[0].key);
    }
  }, [workflowContext, setWorkflow, setCurrentStep]);
}